import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ChangeLogDescription} from 'src/components/change-log';

import {
    entitlementGrantChangeLogStateActions,
    entitlementGrantChangeLogStateSelector,
} from '../slices/entitlement-grant-change-log-state.slice';

type Props = {
    description: string,
};

export const ActionDescriptionCell = ({description}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(entitlementGrantChangeLogStateSelector);
    const query = (cacheKeys.filters?.entitlementName ?? '') as string;

    const onEntityClick = useCallback((entitlementName: string) => {
        dispatch(entitlementGrantChangeLogStateActions.setFilters({entitlementName}));
    }, [dispatch]);

    return (
        <ChangeLogDescription description={description} query={query} onEntityClick={onEntityClick}/>
    );
};
